import { LegalPageLayout } from '../components/LegalPageLayout';

export function Component() {
  return <LegalPageLayout pageId="legal" i18nPrefix="legalNotice" />;
}
